import { ListBox, ListBoxItem, Popover } from "@jugl-web/ui-components";
import { HeaderIconButton } from "@web-src/modules/client-support/components/HeaderIconButton";
import {
  TicketSortDirection,
  useTicketsViewContext,
} from "@web-src/modules/client-support/pages/ClientSupportPage/providers/TicketsViewProvider";
import { FC, ReactNode, useMemo } from "react";
import { ReactComponent as AscIcon } from "./assets/asc.svg";
import { ReactComponent as DescIcon } from "./assets/desc.svg";
import { ReactComponent as SortIcon } from "./assets/sort.svg";

interface SortOptionValue {
  id: TicketSortDirection;
  label: string;
  helperText: string;
  icon: ReactNode;
}

export const TicketsViewSortButton: FC = () => {
  const { sort, setSort } = useTicketsViewContext();

  const items = useMemo<ListBoxItem<SortOptionValue>[]>(
    () => [
      {
        id: "asc",
        value: {
          id: "asc",
          label: "Ascending",
          helperText: "Earliest at the top",
          icon: <AscIcon />,
        },
      },
      {
        id: "desc",
        value: {
          id: "desc",
          label: "Descending",
          helperText: "Newest at the top",
          icon: <DescIcon />,
        },
      },
    ],
    []
  );

  return (
    <Popover
      placement="bottom-end"
      className="w-[220px] p-1.5"
      renderTrigger={({ Trigger, triggerRef, isOpen }) => (
        <Trigger
          as={HeaderIconButton}
          ref={triggerRef}
          icon={<SortIcon />}
          isActive={isOpen}
        />
      )}
    >
      {({ onClose }) => (
        <ListBox
          items={items}
          selectionBehavior={{ mode: "single", canToggle: false }}
          buttonType="radio"
          defaultSelectedIds={[sort]}
          itemSize="2xl"
          spaceBetweenItems="compact"
          renderStartIcon={(item) => item.value.icon}
          renderLabel={(item) => (
            <span className="font-medium">{item.value.label}</span>
          )}
          renderSecondaryText={(item) => item.value.helperText}
          onSelect={(item) => {
            setSort(item.value.id);
            onClose();
          }}
        />
      )}
    </Popover>
  );
};
